<template>
	<section class="content-quote container-fluid col-xs-12" v-if="quoteData.elements">
		
			<div class="quote-text text-center" v-if="quoteData.elements.quote_text">
				"{{ quoteData.elements.quote_text.value }}"

				<span class="author" v-if="quoteData.elements.author">{{ quoteData.elements.author.value }} </span>
			</div>
		

	</section>
</template>

<script>

	import apiConnection from '../mixins/apiConnection.js';


	export default{
		name: 'Quote',
		props:['quoteData'],
		mixins:[apiConnection]
	}
</script>


// WEBPACK FOOTER //
// quote.vue?084fa1f2